import { NotificationState } from 'src/api';
import { useNotificationsQuery } from 'src/graphql';

export const useNotifications = () => {
  const notifications = useNotificationsQuery();

  const numberOfNotifications = notifications.data?.notifications.filter(
    (n) => n.state === NotificationState.CREATED,
  ).length;

  const hasNotifications = Boolean(numberOfNotifications);

  return {
    notifications,
    numberOfNotifications,
    hasNotifications,
  };
};
